module.exports = __webpack_public_path__ + "static/media/lexus-go-drive.c9d0a1a3.png";